var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.66 4.98a9.957 9.957 0 00-3.64-3.639C13.488.447 11.815 0 10 0 8.186 0 6.513.447 4.98 1.341a9.954 9.954 0 00-3.639 3.64C.447 6.512 0 8.185 0 10s.447 3.487 1.341 5.02a9.958 9.958 0 003.64 3.639C6.513 19.553 8.186 20 10 20c1.813 0 3.487-.447 5.019-1.341a9.956 9.956 0 003.639-3.64C19.553 13.488 20 11.815 20 10s-.447-3.488-1.34-5.02zm-2.826 5.853a.8.8 0 01-.248.586.801.801 0 01-.586.248h-3.333V15a.802.802 0 01-.248.586.8.8 0 01-.586.247H9.167a.8.8 0 01-.586-.247.801.801 0 01-.248-.586v-3.333H5a.801.801 0 01-.586-.248.8.8 0 01-.247-.586V9.167a.8.8 0 01.247-.586A.8.8 0 015 8.333h3.334V5a.8.8 0 01.247-.586.8.8 0 01.586-.247h1.667a.8.8 0 01.586.247c.164.165.247.36.247.586v3.333H15a.8.8 0 01.586.248.8.8 0 01.248.586v1.666z","id":"Shape"}));
}

Plus.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Plus;

Plus.default = Plus;
